export default function debug(message) {
	console.log("%c[W-CTF] %c" + message, "color: #8b21e0; font-weight: bold", "");
}
